import "./App.scss";

import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./context/auth.context";
import AppRoutes from "./routes/routes";
import { reactPlugin } from "./services/app-insights.service";

import "ag-grid-enterprise";
import CustomToaster from "./components/CustomToaster";

import { AgChartsEnterpriseModule } from "ag-charts-enterprise";
import { ColumnsToolPanelModule, MasterDetailModule } from "ag-grid-enterprise";

import {
	AlignedGridsModule,
	CellStyleModule,
	ClientSideRowModelModule,
	ColumnApiModule,
	ColumnAutoSizeModule,
	GridStateModule,
	ModuleRegistry,
	PaginationModule,
	RowApiModule,
	ValidationModule,
} from "ag-grid-community";

import {
	CellSelectionModule,
	ColumnMenuModule,
	ContextMenuModule,
	IntegratedChartsModule,
	RowGroupingPanelModule,
	ServerSideRowModelModule,
} from "ag-grid-enterprise";

ModuleRegistry.registerModules([
	ClientSideRowModelModule,
	ColumnsToolPanelModule,
	MasterDetailModule,
	ColumnMenuModule,
	ContextMenuModule,
	AlignedGridsModule,
	ColumnApiModule,
	ColumnAutoSizeModule,
	ServerSideRowModelModule,
	RowApiModule,
	CellStyleModule,
	CellSelectionModule,
	RowGroupingPanelModule,
	GridStateModule,
	PaginationModule,
	IntegratedChartsModule.with(AgChartsEnterpriseModule),
	ValidationModule /* Development Only */,
]);

const FrontendContent = () => {
	return <AppRoutes />;
};

const App = (props: any) => {
	const { instance } = props;

	return (
		<AppInsightsContext.Provider value={reactPlugin}>
			<Router>
				<AuthProvider>
					<div className="App">
						<CustomToaster />
						<FrontendContent />
					</div>
				</AuthProvider>
			</Router>
		</AppInsightsContext.Provider>
	);
};

export default App;
